<template>
    <zen-tooltip
        :content="isFavoriteEnvironment ? 'Clear favorite' : 'Set as favorite'"
        placement="bottom"
        v-slot="{ setReference, ariaAttrs, show, hide }"
    >
        <button
            type="button"
            :ref="setReference"
            v-bind="ariaAttrs"
            @click="toggle"
            @mouseenter="show"
            @mouseleave="hide"
            @focus="show"
            @blur="hide"
            class="cursor-pointer p-1 hover:text-taupe-800 hover:bg-taupe-200 rounded-full"
            :class="
                isFavoriteEnvironment ? 'text-yellow-500' : 'text-taupe-500'
            "
        >
            <zen-icon-favorite v-if="!toggling" css-classes="h-5 w-5" />
            <zen-icon-toggling
                v-if="toggling"
                css-classes="h-5 w-5 text-taupe-800"
            />
        </button>
    </zen-tooltip>
</template>

<script>
import ProfileFavoriteService from '@/services/profile-favorite.service'

import { useSessionStore } from '@/stores/session'

export default {
    computed: {
        sessionStore() {
            return useSessionStore()
        },
        isFavoriteEnvironment() {
            return (
                this.sessionStore.data.user.data.favorites.data.filter(
                    (favorite) =>
                        favorite.project_key.toLowerCase() ===
                            this.project.key.toLowerCase() &&
                        favorite.environment_key.toLowerCase() ===
                            this.environment.key.toLowerCase()
                ).length > 0
            )
        },
    },
    data() {
        return {
            toggling: false,
        }
    },
    methods: {
        toggle() {
            this.toggling = true
            if (this.isFavoriteEnvironment) {
                ProfileFavoriteService.remove(
                    this.project.key,
                    this.environment.key
                ).then(() => {
                    this.sessionStore.removeFavorite(
                        this.project.key,
                        this.environment.key
                    )
                    this.toggling = false
                })
            } else {
                ProfileFavoriteService.create(
                    this.project.key,
                    this.environment.key
                ).then((data) => {
                    this.sessionStore.addFavorite(data.data)
                    this.toggling = false
                })
            }
        },
    },
    props: {
        environment: {
            type: Object,
            required: true,
        },
        project: {
            type: Object,
            required: true,
        },
    },
}
</script>
